import * as React from "react";
const SvgStar = props => <svg width={20} height={20} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}><path style={{
    fill: "none",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }} d="m 10,1.5 2.79198,5.6571692 6.243057,0.9071694 -4.517518,4.4034924 1.066441,6.21783 L 10,15.75 4.4160401,18.685661 5.4824816,12.467831 0.9649631,8.0643386 7.2080199,7.1571694 Z" transform="translate(0,-0.5)" /></svg>;
export default SvgStar;